import type { PanelProps } from "../panel-props"

import { useSelectSettings } from "../../../hooks/use-select-settings"
import { useDatabaseLength } from "../../../modules/database-length-store"
import { useSettings } from "../../../modules/settings"
import { SELECT_CORRECT_RULE_OPTIONS } from "../../../select-correct/rules"
import { useSelectCorrectIndex } from "../../../select-correct/use-select-correct-index"
import { Badge } from "../../badge"
import { Select } from "../../select"
import { Slider } from "../../slider"
import { SharedSettings } from "../shared-settings.tsx"

export function SelectCorrectSettings(input: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()
  const databaseLength = useDatabaseLength()
  const rule = appSettings.selectCorrect.rule
  const { currentIndex, lastIndex, setCurrentIndex } = useSelectCorrectIndex({
    length: databaseLength,
    rule,
  })
  const { onChange, options } = useSelectSettings({
    options: SELECT_CORRECT_RULE_OPTIONS,
    setValue: newValue=> {
      setAppSettings("rule", newValue, "selectCorrect")
    },
  })

  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Rule</h3>
        <Select
          initialValue={rule}
          key={rule}
          label="Selected rule"
          onChange={onChange}
          options={options}
        />
      </section>

      {/* No rule yet means the picker is on screen and there is no list to
          navigate. */}
      {rule !== "" && (
        <>
          <div className="sidebar__separator" role="separator" />

          <section className="sidebar__section">
            <h3 className="sidebar__section-title">Position</h3>
            <Slider
              label="Question index"
              max={lastIndex}
              min={0}
              navigation={{ step: 1 }}
              onValueChange={setCurrentIndex}
              step={1}
              value={currentIndex}
            />
            <div>
              index <Badge value={String(currentIndex)} /> from{" "}
              <Badge value={String(lastIndex)} />
            </div>
          </section>
        </>
      )}
    </SharedSettings>
  )
}
